<div *ngIf="footer" class="container-fluid back-body">
  <div *ngFor="let layout of footer?.templates; let i = index" [ngSwitch]="layout?.typeOf">
    <col-1 *ngSwitchCase="'col-1'" [index]="i" [components]="layout?.components"></col-1>
    <col-21 *ngSwitchCase="'col-21'" [index]="i" [templates]="layout?.components"></col-21>
    <col-2-1-2 *ngSwitchCase="'col-2-1-2'" [index]="i" [templates]="layout?.components"></col-2-1-2>
    <col-2-1-3 *ngSwitchCase="'col-2-1-3'" [index]="i" [templates]="layout?.components"></col-2-1-3>
    <col-2-2-1 *ngSwitchCase="'col-2-2-1'" [index]="i" [templates]="layout?.components"></col-2-2-1>
    <col-2-3-1 *ngSwitchCase="'col-2-3-1'" [index]="i" [templates]="layout?.components"></col-2-3-1>
    <col-31 *ngSwitchCase="'col-31'" [index]="i" [templates]="layout?.components"></col-31>
    <col-3-1-1-2
      *ngSwitchCase="'col-3-1-1-2'"
      [index]="i"
      [templates]="layout?.components"
    ></col-3-1-1-2>
    <col-3-1-2-1
      *ngSwitchCase="'col-3-1-2-1'"
      [index]="i"
      [templates]="layout?.components"
    ></col-3-1-2-1>
    <col-3-2-1-1
      *ngSwitchCase="'col-3-2-1-1'"
      [index]="i"
      [templates]="layout?.components"
    ></col-3-2-1-1>
    <col-421 *ngSwitchCase="'col-421'" [index]="i" [templates]="layout?.components"></col-421>
    <col-632 *ngSwitchCase="'col-632'" [index]="i" [templates]="layout?.components"></col-632>
    <div *ngSwitchDefault></div>
  </div>
</div>

<div
  *ngIf="configService?.versionNumber !== ''"
  class="ag-pa-sm back-body"
  style="text-align: right"
>
  {{ configService?.versionNumber }}
</div>
